

import styled from '@emotion/styled';

import { ButtonLink } from '../Link/Link';

interface CompanyLogoProps {
  smallLogo?: boolean;
}
const CompanyLogo: React.FC<CompanyLogoProps> = ({ smallLogo }) => {
  return (
    <ButtonLink to='/'>
      <Container>
        <WedImage
          width={160}
          src={`/static/img/${smallLogo ? 'cml-logo' : 'cml-logo'
            }.png`}
          alt='Company'
        />
        <MobileImage
          src={`/static/img/${smallLogo ? 'cml-mobile-logo' : 'cml-mobile-logo'
            }.png`}
          alt='Company' />
        {/* <img src="/static/img/companyLogo.png" alt="Company" /> */}
      </Container>
    </ButtonLink>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.12rem;
  font-weight: 500;
  color: black;
  width: fit-content;

  @media screen and (max-width: 884px) {
    width: 79px;
  }
`;

const MobileImage = styled.img`
display: none;
width: 50px;
height: auto;
  @media screen and (max-width: 884px) {
    display: block;
  }
`;

const WedImage = styled.img`
display: block;
width: 160px;
height: auto;
  @media screen and (max-width: 884px) {
    display: none;
  }
`;

export default CompanyLogo;
